import React from 'react';
import { HStack, Box, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Logo({ collapsed = false }: { collapsed?: boolean }): JSX.Element {
  const { t } = useTranslation();
  return (
    <HStack spacing={2} as={Link} to="/" whiteSpace="nowrap" overflow="hidden">
      <Box as="svg" viewBox="0 0 100 100" boxSize="28px">
        <circle cx="50" cy="50" r="46" fill="#3b82f6" />
        <text x="50" y="60" textAnchor="middle" fontSize="48" fontFamily="sans-serif" fill="#fff">
          {t('logo.initial')}
        </text>
      </Box>
      {!collapsed && <Text fontWeight="bold">{t('app.name')}</Text>}
    </HStack>
  );
}
